export const cifTr = ["301 201","<g fill-rule='nonzero' fill='none'><path fill='#E30A17' d='M.5.5h300v200H.5z'/><circle fill='#FFF' cx='106.75' cy='100.5' r='50'/><circle fill='#E30A17' cx='119.25' cy='100.5' r='40'/><path fill='#FFF' d='M146.334 100.5l45.225 14.695-27.951-38.472v47.553l27.951-38.471z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-tr.js
// module id = null
// module chunks = 